import React from "react";
import MoreButton from "./MoreButton";

const FeatureIntegrateHead = () => {
    return (
        <div className="relative overflow-hidden bg-white">
            <div className="py-16 sm:pb-40 sm:pt-24 lg:pb-48 lg:pt-40">
                <div className="relative mx-auto flex max-w-7xl flex-col justify-between gap-8
                px-5 sm:static sm:flex-row sm:pl-10 sm:pr-0 lg:gap-4 lg:pl-8">
                    <div className="sm:max-w-lg">
                        <h1 className="text-h1 font-bold text-gray-900">
                            클라우드 시대의 <br/>
                            데이터 통합 플랫폼
                        </h1>
                        <p className="mt-4 text-h3 font-bold text-brand">
                            노코드 데이터 파이프라인 & 데이터 변환
                        </p>
                        <p className="mt-4 text-body text-gray-500">
                            &quot;Integrate.io는 Xplenty와 FlyData를 기반으로 한 글로벌 데이터 통합 플랫폼입니다. 드래그 앤 드롭 인터페이스를 통해 복잡한 데이터 변환과
                            전송 작업도 손쉽게 처리할 수 있습니다. 완전한 데이터 통합을 향한 여정을 지금 함께하세요.&quot;
                        </p>
                        <MoreButton className="mt-10" />
                    </div>

                    <div className="relative hidden w-full overflow-visible sm:block">
                        <img
                            src="/img/integrate/hero_banner.svg"
                            alt=""
                            className="!absolute !z-[2] !h-full !w-[800px] !max-w-none !object-contain !object-center"
                        />
                    </div>

                    <img
                        src="/img/integrate/gradiant.png"
                        alt=""
                        className="absolute right-[-292px] top-[50%] hidden h-full w-full
                        translate-y-[-50%] object-contain object-center z-[1] sm:block"
                    />
                </div>
            </div>
        </div>
    );
};

export default FeatureIntegrateHead;